import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const LoadingModal = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-[2rem] p-8 shadow-xl text-center w-[90%] max-w-[400px] animate-[popUp_0.3s_ease-out]"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
        >
          <div className="text-4xl mb-4 animate-bounce">🧠</div>
          <h2 className="text-xl font-bold text-slate-800 font-inter">Grading in progress...</h2>
          <p className="text-sm text-slate-600 mt-2 font-inter">Hold tight! Your answer is being reviewed.</p>

          <div className="flex justify-center mt-6">
            <div className="w-10 h-10 border-4 border-dashed border-cyan-500 rounded-full animate-spin border-t-transparent" />
          </div>

          <style>{`
            @keyframes popUp {
              0% { transform: scale(0.9); opacity: 0; }
              100% { transform: scale(1); opacity: 1; }
            }
          `}</style>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default LoadingModal;
